/**
 * EP-150 (App Review, guideline 2.1b): true inside the iOS app, the Capacitor
 * shell around this web app. False on the web and in the Android app.
 *
 * Read from the global the native bridge injects, the way LoginPage reads
 * isNativePlatform, so a test can set it without replacing a module.
 */
interface CapacitorGlobal {
  isNativePlatform?: () => boolean
  getPlatform?: () => string
}

export function isIosApp(): boolean {
  if (typeof window === 'undefined') return false
  const capacitor = (window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor
  return capacitor?.isNativePlatform?.() === true && capacitor.getPlatform?.() === 'ios'
}

/**
 * True inside either native shell (iOS or Android), false on the web.
 *
 * Same global read as `isIosApp`, without the platform check. LoginPage's
 * WKWebView secure-input workaround (see `useMaskedPasswordField`) reads
 * this: the masking is applied on both native platforms, not iOS alone,
 * matching LoginPage's original behavior.
 */
export function isNativePlatform(): boolean {
  if (typeof window === 'undefined') return false
  const capacitor = (window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor
  return capacitor?.isNativePlatform?.() === true
}
